import React, {Fragment, useEffect, useState} from 'react';
import {dateData} from "../components/form/DateTimeInput";
import {sendRequest} from "./request";
import classNames from 'classnames';
import ComponentLoader from "../components/form/ComponentLoader";
import ComponentConfig from "../components/form/ComponentConfig";
import {loadComponent, loadComponentById} from "./components";
import Icon from "../components/form/Icon";
import parse_url from "locutus/php/url/parse_url";
import {unparse_url} from "./url/unparse_url";
import {get, set} from "./dotutils";
import OperationListStock from "../components/editors/OperationList/OperationListStock";
import BigNumber from "bignumber.js";
import {localOptionFilter} from "./filters";
import moment from "moment";
import {copy} from "./other";
import debounce from "./debounce";
import is_numeric from "locutus/php/var/is_numeric";
import {empty} from "locutus/php/var";
import {mathString} from "./math";
import strip_tags from "locutus/php/strings/strip_tags";
import Select from "src/components/form/Select";
import FieldData from 'src/components/form/SelectorGrid/DataGrids/Table/FieldData';

const filterable = true;
const sortable = true;

export const BarcodeFormatter = (input) => {
    if (input.indexOf("ö") !== -1 && !isNaN(input.replace(/ö/g, ''))) {
        input = input.replace(/ö/g, '0');
    }
    if (input.indexOf("`") !== -1 && !isNaN(input.replace(/`/g, ''))) {
        input = input.replace(/`/g, '0');
    }
    if (!isNaN(input)) {
        return parseInt(input);
    }
    return input;
}

export const EmailFormatter = (email) => {
    return email && <a href={"mailto:" + email} target="_blank">{email}</a>;
}

export const TelnumFormatter = (telnum) => {
    return telnum && <a href={"tel:" + telnum} target="_blank">{telnum}</a>;
}

export const AddressFormatter = (address) => {
    return address ? ((address.postcode ? address.postcode + " " : "") + (address.city ? address.city : "") + ((address.postcode || address.city) && address.address ? ", " : "") + (address.address ? address.address : "")) : "";
}

export const UpdatedByFormatter = (updated_by) => {
    return updated_by && updated_by.name;
}

export const UserFormatter = (user) => {
    return user && user.name;
}

export const PercentFormatter = (value) => {
    return <span className={"percent"}>{(value || 0) + " %"}</span>;
}

// TODO majd ezt tényleg currency-re csinálni
export const CurrencyFormatter = (price, currency = null) => {
    let currencyString = "Ft";
    let content;
    if (currency && currency.constructor === {}.constructor) {
        if (currency.currency) {
            if (currency.currency.constructor === {}.constructor) {
                currencyString = currency.currency.symbol || currencyString;
            }
        }
    } else if (currency) {
        currencyString = currency || currencyString;
    }
    if (is_numeric(price)) {
        price = Math.round(new BigNumber(price).multipliedBy(10).dividedBy(10).toNumber());
        // https://medium.com/coding-at-dawn/is-negative-zero-0-a-number-in-javascript-c62739f80114
        // HAHAHAHAHAHHAHAHAAA
        if (price === -0 && !Object.is(+0, price)) {
            price = +0;
        }
        content = price.toLocaleString("hu-HU");
    } else if (!empty(price)) {
        content = price;
    }
    if (content) {
        return <span className={"currency"}>{content + " " + currencyString}</span>
    }
    return <span/>;
}

// TODO majd ezt tényleg currency-re csinálni
export const SignedCurrencyFormatter = (price, currency = null) => {
    if (price !== null && price !== undefined && price !== "") {
        price = Math.round(new BigNumber(price).multipliedBy(10).dividedBy(10).toNumber());
        // https://medium.com/coding-at-dawn/is-negative-zero-0-a-number-in-javascript-c62739f80114
        // HAHAHAHAHAHHAHAHAAA
        if (price === -0 && !Object.is(+0, price)) {
            price = +0;
        }
        const sign = price < 0 ? <span className="sign minus">-</span> : (price > 0 ?
            <span className="sign plus">+</span> : null);
        const clazz = (price < 0 ? "minus" : (price > 0 ? "plus" : ""));
        price = Math.abs(price).toLocaleString("hu-HU");
        return <span className={"currency signed " + clazz}>{sign}{price + " Ft"}</span>;
    }
    return <span/>;
}

export const UnitFormatter = (amount, unit = "db") => {
    if (typeof amount === "object" && amount !== null && amount !== undefined) {
        return amount;
    }
    unit = unit || "db";
    return <span className={"unit"}>{(amount !== null && amount !== undefined && amount !== '' && (amount || 0) + (unit && " " + unit)) || ""}</span>;
}

export const DiscountFormatter = (discount) => {
    return <span className="discount">{parseFloat(discount || 0).toFixed(2) + "%"}</span>;
}

export const OptionFormatter = (option) => {
    return option && option.optionlabel;
}

const optionFormats = {};
const optionRequest = {};

class OptionFormat extends React.Component {

    constructor(props) {
        super(props);
        this.mounted = true;
        const then = (data) => {
            const items = {};
            data.items.map((option) => {
                items[option.optionid] = option
            });
            optionFormats[props.option] = items;
            if (this.mounted) {
                this.forceUpdate();
            }
        };
        if (!optionFormats[props.option] && !optionRequest[props.option]) {
            optionRequest[props.option] = sendRequest({
                option: "componentlist",
                component: "option",
                itemsperpage: 0,
                optionname: props.option
            }, {showError: false});
            optionRequest[props.option].then(then);
            optionRequest[props.option].catch(() => {
                delete optionRequest[props.option];
            });
        } else if (optionRequest[props.option]) {
            optionRequest[props.option].then(then);
            optionRequest[props.option].catch(() => {
                delete optionRequest[props.option];
            });
        }
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        return (
            ((optionFormats[this.props.option] || {})[this.props.value] || {}).optionlabel || this.props.def || this.props.value || null
        );
    }
}

export const remoteOptionFormatter = (option, def) => {
    return (value) => {
        return <OptionFormat def={def} option={option} value={value} />
    }
}

export const localOptionFormatter = (options, def, key = "key", label = "label") => {
    return (value) => {
        return (options.find((option) => option[key] + "" === "" +value) || {})[label] || null;
    }
}

export const LanguageFormatter = (language) => {
    return language && language.hu;
}

const languageFormats = {};
let languageRequest;
const defaultBase = '';
let languageRequestFilter = {};
let languageComponents = [];

const languageRequestLoader = debounce(() => {
    languageRequest && languageRequest.abort();
    languageRequest = sendRequest({
        option: "componentlist",
        component: "language",
        itemsperpage: 0,
        filter: JSON.stringify({
            filters: [
                [
                    {field: "id", value: Object.keys(languageRequestFilter), operator: "in"},
                    {field: "base", value: defaultBase}
                ]
                ,
                ...Object.keys(languageRequestFilter).reduce((all, id) => {
                    const first = languageRequestFilter[id][0] || defaultBase;
                    if (languageRequestFilter[id].length > 1 || (first !== defaultBase && first !== undefined && first !== null)) {
                        all = [
                            ...all,
                            [
                                {field: "id", value: id},
                                languageRequestFilter[id].length > 1
                                    ?
                                    {field: "base", value: languageRequestFilter[id], operator: "in"}
                                    :
                                    {field: "base", value: first}
                            ]
                        ];
                    }
                    return all;
                }, [])
            ],
            operator: "or"
        })
    }, {showError: false});
    languageRequest.then((data) => {
        languageRequestFilter = {};
        data.items.map((language) => {
            languageFormats[language.id] = {...languageFormats[language.id], [language.base]: language}
        });
        languageComponents.map((comp) => {
            if (comp.mounted) {
                comp.forceUpdate();
            }
        });
        languageComponents = [];
    });
}, 300);

export class LanguageFormat extends React.Component {

    constructor(props) {
        super(props);
        this.mounted = false;
    }

    load = () => {
        const base = this.getBase();
        const id = this.getId();
        if (!languageRequestFilter[id]) {
            languageRequestFilter[id] = [];
        }
        if (!languageFormats[id]) {
            languageFormats[id] = {};
        }
        languageComponents.push(this);
        if (languageRequestFilter[id].indexOf(base) === -1 && languageFormats[id][base] === undefined) {
            languageRequest && languageRequest.abort();
            languageRequest = null;
            languageRequestFilter[id].push(base);
            languageRequestLoader();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.base !== prevProps.base || this.props.id !== prevProps.id) {
            this.load();
        }
    }

    getBase = () => {
        return this.props.base || defaultBase;
    }

    getId = () => {
        return this.props.id || '';
    }

    componentDidMount() {
        this.mounted = true;
        this.load();
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    render() {
        return get(languageFormats, this.getId() + "." + this.getBase() + ".hu", get(languageFormats, this.getId() + "." + defaultBase + ".hu", this.props.def || this.getId() || null)) || null;
    }
}

export const remoteLanguageFormatter = (base) => {
    return (token, def) => {
        return <LanguageFormat id={token} base={base} def={def} />
    }
}

const componentNames = {};

export class ComponentName extends React.Component {

    constructor(props) {
        super(props);
        if (!(componentNames[this.props.component] || {})[this.props.component_id]) {
            this.state = {
                name: null
            };
            this.componentDidUpdate({}, this.props);
        } else {
            this.state = {
                name: componentNames[this.props.component][this.props.component_id]
            };
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.component !== prevProps.component || this.props.component_id !== prevProps.component_id) {
            if (!(componentNames[this.props.component] || {})[this.props.component_id]) {
                this.load && this.load.abort();
                this.load = loadComponentById(this.props.component, this.props.component_id, ["displayname", "name", "title"]);
                this.load.then((component) => {
                    if (!componentNames[this.props.component]) {
                        componentNames[this.props.component] = {};
                    }
                    componentNames[this.props.component][this.props.component_id] = component.displayname || component.name || component.title;
                    this.setState({
                        name: componentNames[this.props.component][this.props.component_id]
                    });
                });
            } else {
                this.setState({
                    name: componentNames[this.props.component][this.props.component_id]
                });
            }
        }
    }

    render() {
        return (
            this.state.name || this.props.children
        );
    }
}

export const DateFormatter = (date) => (date && dateData(date, true).momentValue.format("YYYY.MM.DD.")) || date;
export const DateTimeFormatter = (date) => (date && dateData(date, true).momentValue.format("YYYY.MM.DD. HH:mm:ss")) || date;

export const PeriodFormatter = (period) => {
    let from = null;
    let to = null;
    if (Array.isArray(period)) {
        if (period[0]) {
            from = moment(period[0], "YYYY-MM-DD HH:mm:ss");
        }
        if (period[1]) {
            to = moment(period[1], "YYYY-MM-DD HH:mm:ss");
        }
    } else if (period && period instanceof Object) {
        if (period.from) {
            from = moment(period.from, "YYYY-MM-DD HH:mm:ss");
        }
        if (period.to) {
            to = moment(period.to, "YYYY-MM-DD HH:mm:ss");
        }
    } else {
        return period ? DateFormatter(period) : period;
    }
    let string = [];
    const today = moment().startOf('day');
    const yesterday = moment().subtract(1, 'days').startOf('day');
    const tomorrow = moment().add(1, 'days').startOf('day');
    let key = -1;
    const date = (from, to) => {
        to = to || today;
        let date = [];
        let dateKey = -1;
        const sameYear = from.format("YYYY") === to.format("YYYY");
        const sameMonth = from.format("MM") === to.format("MM");
        const sameDay = from.format("DD") === to.format("DD");
        if (!sameYear) {
            date.push(<span key={++dateKey} className="year">{from.format("YYYY")}</span>)
        }
        if (!sameYear || !sameMonth) {
            date.push(<span key={++dateKey} className={classNames("month", {"text": sameYear})}>{sameYear ? from.format("MMM") : from.format("MM")}</span>);
        } else if (sameYear && sameMonth && today.isSame(from, 'month')) {
            date.push(<span key={++dateKey} className={classNames("month", {"text": sameYear})}>{sameYear ? from.format("MMM") : from.format("MM")}</span>);
        }
        if (!sameYear || !sameMonth || !sameDay) {
            date.push(<span key={++dateKey} className="day">{from.format("DD")}</span>);
        }
        return date;
    }
    const time = (from, to) => {
        //if (from && to && from.format("mm:ss") === "00:00" && to.format("mm:ss") === "00:00") {
        //    string.push(<span key={++key} className="time">{parseInt(from.format("HH")) + " órától " + parseInt(to.format("HH")) + " óráig"}</span>);
        //} else {
            string.push(<span key={++key} className="time">{(from || to).format("HH:mm") + " - " + (to || from).format("HH:mm")}</span>);
        //}
    }
    if (from && to) {
        if (from.isSame(to, 'day')) {
            if (to.isSame(today, 'day')) {
                string.push(<span key={++key} className="date"><span className="day today">Ma</span></span>);
            } else if (to.isSame(tomorrow, 'day')) {
                string.push(<span key={++key} className="date"><span className="day tomorrow">Holnap</span></span>);
            } else if (to.isSame(yesterday, 'day')) {
                string.push(<span key={++key} className="date"><span className="day yesterday">Tegnap</span></span>);
            } else {
                string.push(<span key={++key} className="date">{date(from)}</span>);
            }
        } else if (from.isSame(to, 'year')) {
            string.push(<span key={++key} className="date">{date(from)}<span className="divider">-</span>{date(to, from)}</span>);
        } else {
            string.push(<span key={++key} className="date">{date(from)}</span>);
            string.push(<span key={++key} className="date">{date(to)}</span>);
        }
        time(from, to);
    } else if (from) {
        if (from.isSame(today, 'day')) {
            string.push(<span key={++key} className="date"><span className="day today">Ma</span></span>);
        } else if (from.isSame(tomorrow, 'day')) {
            string.push(<span key={++key} className="date"><span className="day tomorrow">Holnap</span></span>);
        } else if (from.isSame(yesterday, 'day')) {
            string.push(<span key={++key} className="date"><span className="day yesterday">Tegnap</span></span>);
        } else {
            string.push(<span key={++key} className="date">{date(from)}</span>);
        }
        string.push(<span key={++key} className="time">{from.format("HH:mm")}</span>);
    } else if (to) {
        if (to.isSame(today, 'day')) {
            string.push(<span key={++key} className="date"><span className="day today">Ma</span></span>);
        } else if (to.isSame(tomorrow, 'day')) {
            string.push(<span key={++key} className="date"><span className="day tomorrow">Holnap</span></span>);
        } else if (to.isSame(yesterday, 'day')) {
            string.push(<span key={++key} className="date"><span className="day yesterday">Tegnap</span></span>);
        } else {
            string.push(<span key={++key} className="date">{date(to)}</span>);
        }
        string.push(<span key={++key} className="time">{to.format("HH:mm")}</span>);
    }
    return <span className="period">{string}</span>;
}

const componentFormats = {};
const componentRequest = {};

class ComponentFormat extends React.Component {
    constructor(props) {
        super(props);
        if (props.onlyThis) {
            const then = (data) => {
                const items = {};
                data.items.map((component) => {
                    items[component[props.idfield || props.componentConfig.idfield]] = component
                });
                componentFormats[props.component] = {...(componentFormats[props.component] || {}), ...items};
                this.forceUpdate();
            };
            if (!this.request) {
                this.request = sendRequest({
                    option: "componentlist",
                    component: props.component,
                    itemsperpage: 0,
                    filter: [{field: props.componentConfig.idfield, value: props.value}]
                }, {showError: false});
                this.request.then(then);
                this.request.catch(() => {
                    delete this.request;
                });
            } else if (this.request) {
                this.request.then(then);
                this.request.catch(() => {
                    delete this.request;
                });
            }
        } else {
            const then = (data) => {
                const items = {};
                data.items.map((component) => {
                    items[component[props.idfield || props.componentConfig.idfield]] = component
                });
                componentFormats[props.component] = {...(componentFormats[props.component] || {}), ...items};
                this.forceUpdate();
            };
            if (!componentFormats[props.component] && !componentRequest[props.component]) {
                componentRequest[props.component] = sendRequest({
                    option: "componentlist",
                    component: props.component,
                    itemsperpage: 0,
                }, {showError: false});
                componentRequest[props.component].then(then);
                componentRequest[props.component].catch(() => {
                    delete componentRequest[props.component];
                });
            } else if (componentRequest[props.component]) {
                componentRequest[props.component].then(then);
                componentRequest[props.component].catch(() => {
                    delete componentRequest[props.component];
                });
            }
        }
    }

    render() {
        return (
            ((componentFormats[this.props.component] || {})[this.props.value] || {})[this.props.labelfield || "name"] || this.props.value || null
        );
    }
}

export const remoteComponentFormatter = ({component, labelfield = null, idfield = null}, onlyThis = false) => {
    return (value) => {
        return <ComponentConfig componentName={component} loader={() => null}>
            <ComponentFormat component={component} value={value} idfield={idfield} labelfield={labelfield} onlyThis={onlyThis} />
        </ComponentConfig>;
    }
}

export class LocationSelect extends React.Component {

    static view = ["name", "address"];

    render() {
        return (
            <div className="location-select">
                <div className="details">
                    <div className="name">{this.props.name}</div>
                    <div className="address">{AddressFormatter(this.props.address)}</div>
                </div>
            </div>
        );
    }
}

export class NewsletterSelect extends React.Component {

    static component = "Newsletter";

    static view = ["name", "id", "subject"];

    static columns = {
        "id": {
            header: 'Kód',
            width: 1,
            filterable,
            sortable,
        },
        "name": {
            header: 'Név',
            width: 5,
            filterable,
            sortable
        },
        "created_by.name": {
            header: 'Létrehozta',
            width: 2,
            sortable
        },
        "updated_by.name": {
            header: 'Módosította',
            width: 2,
            sortable
        },
        "updated_at": {
            header: 'Módosítás dátuma',
            width: 2,
            sortable,
            renderer: DateFormatter
        }
    };

    render() {

        return (
            <div className="newsletter-select">
                <div className="details">
                    <div className="name">{this.props.name} <span className="id">(#{this.props.id})</span></div>
                    <div className="subject">{this.props.subject}</div>
                </div>
            </div>
        );
    }
}

export class PollSelect extends React.Component {

    static view = ["title", "description"];

    render() {
        return (
            <div className="newsletter-select">
                <div className="details">
                    <div className="title">{this.props.title} <span className="id">(#{this.props.id})</span></div>
                    <div className="desc">{strip_tags(this.props.description)}</div>
                </div>
            </div>
        );
    }
}

export class CouponSelect extends React.Component {

    static component = "discount";

    static view = ["id", "promo_code"];

    static columns = {
        "id": {
            header: 'Kód',
            width: 1,
            filterable,
            sortable,
        },
        "promo_code": {
            header: 'Kupon kód',
            width: 4,
            filterable,
            sortable
        },
        "name": {
            header: 'Kedvezmény',
            width: 4,
            filterable,
            sortable
        },
        "promotion.name": {
            header: 'Akció',
            width: 4,
            filterable,
            sortable
        },
    };

    render() {
        return (
            <div className="coupon-select">
                <div className="details">
                    <div className="promo_code">{this.props.promo_code} <span className="id">(#{this.props.id})</span></div>
                    <div className="desc">{this.props.description}</div>
                </div>
            </div>
        );
    }
}

export const optionsTemplate = (component) => {
    if (component === "partner") {
        return PartnerSelect;
    } else if (component === "product") {
        return ProductSelect;
    } else if (component === "Newsletter") {
        return NewsletterSelect;
    } else if (component === "location") {
        return LocationSelect;
    } else if (component === "person") {
        return PersonSelect;
    } else if (component === "user") {
        return UserSelect;
    } else if (component === "author") {
        return AuthorSelect;
    } else if (component === "Event") {
        return EventSelect;
    } else if (component === "Poll") {
        return PollSelect;
    } else if (component === "coupon") {
        return CouponSelect;
    } else if (component === "Material") {
        return MaterialSelect;
    }
};

export class SelectOptionVisualizer extends React.Component {
    render() {
        const childFunc = (child, idx) => {
            let childComp = null;
            if (child?.type?.prototype) {
                childComp = <child.type {...child.props} />;
            } else if (child instanceof Function) {
                childComp = child;
            }
            if (childComp) {
                return <div
                    key={idx}
                    className="react-select__option"
                    id="react-select-2-option-1"
                    tabIndex="-1"
                >
                    {childComp}
                </div>
            } else {
                return null;
            }
        };
        let children = this.props.children;
        if (Array.isArray(children)) {
            children = children.map(childFunc).filter(Boolean);
        } else {
            children = childFunc(children);
        }
        return (
            <div className={classNames("react-select__menu", this.props.className)}>
                <div className="react-select__menu-list react-select__menu-list--is-multi">
                    {children}
                </div>
            </div>
        );
    }
}

export class EventSelect extends React.Component {

    static view = ["program.displayname", "locations.name", "from", "to", "program.prices"];

    render() {
        return (
            <div className="event-select">
                <div className="declaration">
                    {PeriodFormatter([this.props.from, this.props.to])}
                </div>
                <div className="details">
                    <div className="name">{this.props.program.displayname}</div>
                    <div className="locations">{(this.props.locations || []).map((location, idx) => {
                        return <span key={idx} className="name">{location.name}</span>;
                    }).reduce((prev, curr) => [prev, prev ? ', ' : '', curr], null)}</div>
                    <div className="declaration">
                        {PeriodFormatter([this.props.from, this.props.to])}
                    </div>
                    {this.props.price !== undefined ? <div className={classNames("price", {"group": this.props.price.group_price})}>
                        {CurrencyFormatter(this.props.price.price || this.props.price.group_price, this.props.currency)}
                    </div>: null}
                </div>
            </div>
        );
    }
}

export const ProductTooltip = ({row, idfield}) => {
    return <ComponentLoader componentName="product" componentId={get(row, idfield)} view={ProductSelect.view}>
        {(data) => <ProductSelect {...data.values}/>}
    </ComponentLoader>;
}

export const productTooltip = (idfield) => (value, rowData) => {
    return <ProductTooltip row={rowData} idfield={idfield} />
}

export const ProductDisplayName = ({value, row, idfield}) => {
    const href = parse_url(window.location.href);
    href.fragment = "/?option=product&id=" + get(row, idfield);
    return <Fragment>{value} <span className="product-actions"><OperationListStock productId={get(row, idfield)} product={row} /><a href={unparse_url(href)} target="_blank"><Icon lib="fas" name="external-link-alt" tooltip="Termék adatlap" /></a></span></Fragment>;
}

export const ProductName = (idfield) => (value, row) => {
    return <ProductDisplayName value={value} row={row} idfield={idfield} />
}

export const ProductColumn = (idfield, ifFn) => ({
    header: 'Megnevezés',
    sortable: true,
    filterable: true,
    renderer: (...args) => ifFn ? ifFn(ProductName(idfield), ...args) : ProductName(idfield)(...args),
    tooltip: (...args) => ifFn ? ifFn(productTooltip(idfield), ...args) : productTooltip(idfield)(...args)
});

export class MaterialSelect extends React.Component {

    static component = "Material";

    static view = ["id", "displayname"];

    static columns = {
        "displayname": {
            header: 'Megnevezés',
            sortable: true,
            filterable: true,
            width: 9,
        }
    }

    render() {
        return (
            <div className="material-select">
                <div className="details">
                    <div className="name">{this.props.displayname} (#{this.props.id})</div>
                </div>
            </div>
        );
    }
}


export class ProductSelect extends React.Component {

    static component = "product";

    static view = ["id", "displayname", "barcode", "sku", "listprice", "cover_image", "tradename", "sortiments"];

    static columns = {
        "displayname": {
            ...ProductColumn("id"),
            width: 9,
        },
        "sku": {
            header: 'ISBN',
            width: 1,
            sortable: true,
            filterable: true
        },
        "barcode": {
            header: 'Vonalkód',
            width: 1,
            sortable: true,
            filterable: true
        },
        "listprice": {
            header: 'Ár',
            width: 1,
            sortable: true,
            filterable: true,
            renderer: CurrencyFormatter,
            className: "currency"
        },
    }

    render() {
        return (
            <div className="product-select">
                <div className="image">
                    {this.props.cover_image && <img src={this.props.cover_image.url} />}
                </div>
                <div className="details">
                    <div className="name">{this.props.displayname} (#{this.props.id})</div>
                    <div className="tradename">{(this.props.tradename || {}).name}</div>
                    <div className="spec">
                        {!!this.props.barcode && <span className="barcode">(Vonalkód: {this.props.barcode})</span>}
                        {!!this.props.sku && <span className="sku">(Sku: {this.props.sku})</span>}
                        {!!this.props.listprice && <span className="price">{this.props.listprice} Ft</span>}
                        {Array.isArray(this.props.sortiments) && !!this.props.sortiments.length && <div className="sortiments">Szortimentek: {this.props.sortiments.map((sortiment, idx) => <span key={idx} className="sortiment">{sortiment.name}</span>)}</div>}
                    </div>
                </div>
            </div>
        );
    }
}

export class ProductSelectSmall extends React.Component {

    static view = ["displayname", "listprice", "cover_image"];

    render() {
        return (
            <div className="product-select">
                <div className="image">
                    {this.props.cover_image && <img src={this.props.cover_image.url} />}
                </div>
                <div className="details">
                    <div className="name">{this.props.displayname}</div>
                    <div className="spec">
                        {!!this.props.listprice && <span className="price">{this.props.listprice} Ft</span>}
                    </div>
                </div>
            </div>
        );
    }
}

export class AgentSelect extends React.Component {

    static view = ["name", "email", "address"];

    render() {
        return (
            <div className="person-select">
                <div className="name">{this.props.name}</div>
                <div className="email">{this.props.email}</div>
                <div className="address">{AddressFormatter(this.props.address)}</div>
            </div>
        );
    }
}

export class PartnerSelect extends React.Component {

    static view = ["name", "address", "taxid", "group_id", "group_taxid", "eu_taxid"];

    render() {
        if (!this.props.partner_id && !this.props.isNew) {
            return this.props.name || '';
        }
        const address = AddressFormatter(this.props.address);
        return (
            <div className="partner-select">
                <div className="name">{this.props.name}<span className={classNames("taxid", {"not-set": !(this.props.taxid || this.props.eu_taxid || this.props.group_taxid)})}>({this.props.taxid || this.props.eu_taxid || this.props.group_taxid || "Nincs megadva adószám!"})</span> {this.props.group_taxid ? <span className={classNames("group_id")}>({this.props.group_id || "Nincs megadva csoport azonosító!"})</span> : null}</div>
                <div className={classNames("address", {"not-set": !address})}>{address || (!this.props.partner_id && this.props.isNew ? "Új partner" : "Nincs megadva számlázási cím!")}</div>
            </div>
        );
    }
}

export class PersonSelect extends React.Component {

    static view = ["name", "email", "address"];

    render() {
        const address = AddressFormatter(this.props.address);
        return (
            <div className="person-select">
                <div className="name">{this.props.name}</div>
                <div className="email">{this.props.email}</div>
                <div className={classNames("address", {"not-set": !address})}>{address || "Nincs megadva cím."}</div>
            </div>
        );
    }
}

export class UserSelect extends React.Component {

    static view = ["name", "email", "address"];

    render() {
        const address = AddressFormatter(this.props.address);
        return (
            <div className="user-select">
                <div className="name">{this.props.name}</div>
                <div className="email">{this.props.email}</div>
                <div className={classNames("address", {"not-set": !address})}>{address || "Nincs megadva cím."}</div>
            </div>
        );
    }
}

export class AuthorSelect extends React.Component {

    static view = ["name", "alias", "images"];

    render() {
        return (
            <div className="author-select">
                <div className="image">
                    {!!(this.props.images || []).length && <img src={this.props.images[0].url} />}
                </div>
                <div className="details">
                    <div className="name">{this.props.name}</div>
                    <div className="alias">{this.props.alias}</div>
                </div>
            </div>
        );
    }
}

export const localOptionColumn = (options) => ({
    filterable: localOptionFilter(options),
    renderer: localOptionFormatter(options),
});

const componentTranslate = {
    "invoice": "Számla",
    "stocktransfer": "Szállítás",
    "purchase": "Tranzakció",
    "StoreOrderClaim": "Reklamáció",
    "WriteOff": "Leírás",
    "storeorder": "Raktári rendelés",
    "MoneyTransfer": "Fizetés",
    "TransactionPayment": "Fizetés",
    "EventReservation": "Foglalás",
    "EventPurchase": "Jegy eladás",
    "location": "Helység",
    "LocationSection": "Szekció",
};

export const ComponentOptions = Object.keys(componentTranslate).map((key) => ({key, label: componentTranslate[key]}));

export const ComponentFormatter = ({component, componentId = null, base = '', def = null}) => {
    if (!componentId) {
        return remoteLanguageFormatter(base)(component, componentTranslate[component] || def || component);
    }
    return <ComponentName component={component} component_id={componentId}>{remoteLanguageFormatter('')(component, def)}{" (#" + componentId + ")"}</ComponentName>
}

export const CopyFormatter = (value) =>
    value ?
        <Fragment>
            {value}
            {" "}
            <Icon
                lib="fas"
                name="copy"
                className="pull-right"
                tooltip="Másolás"
                onClick={(e) => {
                    e && e.stopPropagation();
                    e && e.preventDefault();
                    copy(value);
                }}
            />
        </Fragment>
        :
        value;

export const PidFormatter = CopyFormatter;

export const relativeTimeFormatter = props => {
    const language = props.language || "hu";
    let time = props.seconds;
    let type = "seconds";
    if (Math.abs(time) >= 31556926) {
        type = "year";
        time = Math.floor(time / 31556926)
    } else if (Math.abs(time) >= 2629744) {
        type = "month";
        time = Math.floor(time / 2629744)
    } else if (Math.abs(time) >= 604800) {
        type = "week";
        time = Math.floor(time / 604800)
    } else if (Math.abs(time) >= 86400) {
        type = "day";
        time = Math.floor(time / 86400)
    } else if (Math.abs(time) >= 3600) {
        type = "hour";
        time = Math.floor(time / 3600)
    } else if (Math.abs(time) >= 60) {
        type = "minute";
        time = Math.floor(time / 60)
    }
    const rtf2 = new Intl.RelativeTimeFormat(language, {numeric: 'auto'});
    return rtf2.format(time, type);
}

export const currencyMathString = (str, args, formats = {}) => {
    return mathString(str, args, {
        ...formats,
        forAll: (formats?.forAll || ((value) => CurrencyFormatter(value).props.children))
    })
}


const optionRequests = {};
const loadedOptions = [];

export const DataGridOptionFormatter = ({optionname}) => ({value}) => {
    const [options, setOptions] = useState(loadedOptions.filter((option) => option.optionname === optionname));
    useEffect(() => {
        if (!options.length) {
            const request = optionRequests[optionname] = optionRequests[optionname] ?? (() => {
                let request;
                let debounce;
                const r = new Promise((resolve, reject) => {
                    debounce = setTimeout(() => {
                        request = loadComponent("componentlist", {
                            component: "option",
                            itemsperpage: 0,
                            optionname,
                            view: ["optionname", "optionid", "optionlabel"]
                        }).then(resolve, reject);
                    }, 300);
                });
                r.abort = () => {
                    clearTimeout(debounce);
                    request?.abort();
                }
                return r;
            })()
            request.then(({items}) => {
                loadedOptions.push(...items);
                setOptions(items);
                delete optionRequests[optionname];
            }).catch(() => {
                delete optionRequests[optionname];
            });
            return () => {
                delete optionRequests[optionname];
                request.abort();
            }
        }
    }, []);
    return options.find((option) => option.optionid === value)?.optionlabel ?? null;
}

export const DataGridOptionFilter = ({optionname}) => (props) => {
    let filter = props.filter || {field: props.filterField || props.field, value: null, operator: "="};
    return <Select
        storeType="local"
        label={false}
        value={filter.value}
        isClearable={true}
        optionname={optionname}
        objectValue={false}
        saveChanges={(field, value) => {
            if (value) {
                props.setFilter({...filter, value});
            } else {
                props.setFilter(undefined);
            }
        }}
    />
}

export const DataGridCurrencyFormatterFactory = () => ({value}) => {
    return CurrencyFormatter(value);
}

export const DataGridCurrencyFormatter = DataGridCurrencyFormatterFactory();

const setPrice = ({value, field, row}) => {
    let oldItem = {...row};
    let newItem = {...row};
    set(newItem, field, value);
    if (!oldItem.vat) {
        oldItem = {...newItem};
    }
    if (newItem.vat) {
        const saleprice = calculateItemPrice("saleprice", field, newItem, oldItem, PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE);
        saleprice.setPrice(newItem.saleprice);
        const listprice = calculateItemPrice("listprice", field, newItem, oldItem, PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE);
        listprice.setPrice(newItem.listprice);

        if (field === "discount") {
            saleprice.setPrice(new BigNumber(listprice.getPrice()).minus(new BigNumber(listprice.getPrice()).dividedBy(100).multipliedBy(newItem.discount).toNumber()));
        } else {
            newItem.discount = Number(new BigNumber(100).minus(new BigNumber(saleprice.getPrice()).dividedBy(listprice.getPrice()).multipliedBy(100)).toNumber().toFixed(2));
        }

        saleprice.boundTo(newItem, "saleprice");
        listprice.boundTo(newItem, "listprice");
        newItem.saleprice = saleprice.getPrice();
        newItem.listprice = listprice.getPrice();
    }
    return newItem;
}

export const DataGridPriceFieldFactory = () => {
    return class PriceFieldComponent extends FieldData {
        getFormatter() {
            const formatters = super.getFormatter();
            if (!formatters.length) {
                return [<Fragment key="0">{CurrencyFormatter(this.props.value)}</Fragment>];
            }
            return formatters;
        }

        getEditor() {
            const editors = super.getEditor();
            if (this.props.field !== "listprice" && !editors.length) {
                return [
                    <TextInput
                        key="0"
                        type="decimal"
                        name={this.props.field}
                        label={false}
                        focus
                        value={this.props.value}
                        onKeyDown={(e, field, value) => {
                            if (ifCompletedInput(e)) {
                                this.props.editItems({[this.props.rowKey]: setPrice({...this.props, value})});
                            }
                        }}
                        onBlur={(e, field, value) => {
                            this.props.editItems({[this.props.rowKey]: setPrice({...this.props, value})});
                        }}
                    />
                ];
            } else {
                return editors;
            }
        }

        layout(props, state) {
            if (props.className instanceof Function) {
                props = {...props};
                props.className = classNames(props.className(props), "currency");
            } else {
                props = {...props};
                props.className = classNames(props.className, "currency");
            }
            return super.layout(props, state);
        }
    }
}

export const DataGridPriceField = DataGridPriceFieldFactory();

export const DataGridVatrateFieldFactory = () => {
    return class VatrateFieldComponent extends FieldData {
        getFormatter() {
            const formatters = super.getFormatter();
            if (!formatters.length) {
                return [<span key="0" className="vat">{this.props.value?.name}</span>];
            }
            return formatters;
        }

        getEditor() {
            const editors = super.getEditor();
            if (!editors.length) {
                return [
                    <Select
                        name={this.props.field}
                        component="vatrate"
                        filter={{field: "active", value: 1}}
                        objectValue={true}
                        label={false}
                        storeType="local"
                        value={this.props.value}
                        view={["rate"]}
                        saveChanges={(field, value) => {
                            this.props.editItems({[this.props.rowKey]: setPrice({...this.props, value})});
                        }}
                    />
                ];
            } else {
                return editors;
            }
        }

        layout(props, state) {
            if (props.className instanceof Function) {
                props = {...props};
                props.className = classNames(props.className(props), "vat");
            } else {
                props = {...props};
                props.className = classNames(props.className, "vat");
            }
            return super.layout(props, state);
        }
    }
}

export const DataGridVatrateField = DataGridVatrateFieldFactory();

export const DataGridQtyFieldFactory = () => {
    return class QtyFieldComponent extends FieldData {
        getFormatter() {
            const formatters = super.getFormatter();
            if (!formatters.length) {
                return [<UnitConvertComponent key="0" value={this.props.value ?? 0} unit={this.props.row.unit} />];
            }
            return formatters;
        }

        getEditor() {
            const editors = super.getEditor();
            if (!editors.length) {
                return [
                    <TextInput
                        key="0"
                        type="number"
                        name={this.props.field}
                        label={false}
                        focus
                        value={this.props.value}
                        onKeyDown={(e, field, value) => {
                            value = parseInt(value || "0");
                            let oldvalue = parseInt(this.props.value || "0");
                            if (oldvalue !== value) {
                                if (ifCompletedInput(e)) {
                                    if (value === 0) {
                                        this.removeItems({[this.props.rowKey]: this.props.row});
                                    } else {
                                        this.props.editItems({[this.props.rowKey]: setPrice({...this.props, value})});
                                    }
                                }
                            }
                        }}
                        onBlur={(e, field, value) => {
                            value = parseInt(value || "0");
                            let oldvalue = parseInt(this.props.value || "0");
                            if (oldvalue !== value) {
                                if (value === 0) {
                                    this.removeItems({[this.props.rowKey]: this.props.row});
                                } else {
                                    this.props.editItems({[this.props.rowKey]: setPrice({...this.props, value})});
                                }
                            }
                        }}
                    />
                ];
            } else {
                return editors;
            }
        }

        layout(props, state) {
            if (props.className instanceof Function) {
                props = {...props};
                props.className = classNames(props.className(props), "unit");
            } else {
                props = {...props};
                props.className = classNames(props.className, "unit");
            }
            return super.layout(props, state);
        }
    }
}

export const DataGridQtyField = DataGridQtyFieldFactory();
